export const namespace = 'inputMessages';

export const MutationTypes = {
  SET_INPUT_MESSAGE: 'SET_INPUT_MESSAGE',
  SET_INPUT_MESSAGES: 'SET_INPUT_MESSAGES',
};

export const ActionTypes = {
  GET_INPUT_MESSAGE: 'GET_INPUT_MESSAGE',
  GET_INPUT_MESSAGES: 'GET_INPUT_MESSAGES',
};
